import { EntityLinks, ID, IDPrefixes, PrefixedID } from '@griply/types';

import { hasCompositeIdPrefix } from '../encoded-ids/composite-id';
import { getPrefixedId } from '../prefix-id';

const selectIds = (
  references: PrefixedID[] | undefined,
  prefix: IDPrefixes,
): ID[] =>
  references
    ?.filter((reference) => hasCompositeIdPrefix(reference, prefix))
    .map((reference) => getPrefixedId(reference)) ?? [];

export const getLinkedIds = (
  links: EntityLinks,
  linkingId: PrefixedID,
  prefix: IDPrefixes,
): ID[] => selectIds(links.outgoing[linkingId], prefix);

export const getLinkingIds = (
  links: EntityLinks,
  linkedId: PrefixedID,
  prefix: IDPrefixes,
): ID[] => selectIds(links.incoming[linkedId], prefix);
